export default {"src":"/_next/static/media/mode_computer_medium.1c7cc2c2.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};